export default {
  title: process.env.REACT_APP_TITLE ? process.env.REACT_APP_TITLE : 'Catálogo de Prêmios | Premmiar',
  description:
    'O WebPrêmios é um marketplace com design integrado que oferece uma experiência interativa ao participante, possibilitando a personalização do catálogo sem necessidade de envolvimento de técnicos ou intermediários. Entre suas facilidades estão telas de comparativo de preços, carrinho único, tracking, navegação com menos cliques, atendimento por chat e cross-selling de produtos.',
  keywords: ''
}



// WEBPACK FOOTER //
// ./src/redux/initial-state/meta.js